import { inject, Injectable, OnDestroy, signal } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { Menu } from 'src/app/core/constants/menu';
import { TipoUsuario } from 'src/app/core/enum/global.enum';
import { MenuItem, SubMenuItem } from 'src/app/core/models/menu.model';
import { GuardService } from 'src/app/core/services/guards.service';

@Injectable({
  providedIn: 'root',
})
export class MenuService implements OnDestroy {

  modalDetalleTransaccionVisible: boolean = false;
  private _baseMenu: MenuItem[] = Menu.pages;

  private _showSidebar = signal(true);
  private _showMobileMenu = signal(false);
  private _pagesMenu = signal<MenuItem[]>(this._baseMenu);
  private _subscription = new Subscription();

  constructor(private router: Router) {
    /** Set dynamic menu */
    this._pagesMenu.set(Menu.pages);

    let sub = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        /** Expand menu base on active route */
        this._pagesMenu().forEach((menu) => {
          let activeGroup = false;
          menu.items.forEach((subMenu) => {
            const active = this.isActive(subMenu.route);
            subMenu.expanded = active;
            subMenu.active = active;
            if (active) activeGroup = true;
            if (subMenu.children) {
              this.expand(subMenu.children);
            }
          });
          menu.active = activeGroup;
        });
      }
    });
    this._subscription.add(sub);
  }

  get showSideBar() {
    return this._showSidebar();
  }
  get showMobileMenu() {
    return this._showMobileMenu();
  }
  get pagesMenu() {
    return this._pagesMenu();
  }

  set showSideBar(value: boolean) {
    this._showSidebar.set(value);
  }
  set showMobileMenu(value: boolean) {
    this._showMobileMenu.set(value);
  }

  public toggleSidebar() {
    this._showSidebar.set(!this._showSidebar());
  }

  public toggleMenu(menu: any) {
    this.showSideBar = true;
    menu.expanded = !menu.expanded;
  }

  public toggleSubMenu(submenu: SubMenuItem) {
    submenu.expanded = !submenu.expanded;
  }

  public applyMenuVisibility(tipoUsuarioId: number | undefined | null) {
    const id = Number(tipoUsuarioId ?? 0);
    const isAdmin = id === TipoUsuario.USUARIO_ADMINISTRADOR;
    const updated = this._baseMenu.map(group => ({
      ...group,
      items: group.items
        .map(item => ({
          ...item,
          show: item.show ?? true,
          ...(item.route === '/representante-legal' ? { show: isAdmin } : {}),
        }))
        .filter(item => item.show !== false),
    }));

    this._pagesMenu.set(updated);
  }

  private expand(items: Array<any>) {
    items.forEach((item) => {
      item.expanded = this.isActive(item.route);
      if (item.children) this.expand(item.children);
    });
  }

  private isActive(instruction: any): boolean {
    return this.router.isActive(this.router.createUrlTree([instruction]), {
      paths: 'subset',
      queryParams: 'subset',
      fragment: 'ignored',
      matrixParams: 'ignored',
    });
  }

  ngOnDestroy(): void {
    this._subscription.unsubscribe();
  }
}
